import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import aa from "../AdminPortal/adminApp.module.css";
import s from "../clinic.module.css";

export function ClientProfileCollapsible({
  id,
  title,
  preview,
  open,
  onToggle,
  children,
}) {
  const isApp = useAdminHubUi();

  if (isApp) {
    return (
      <section
        id={id}
        className={`${aa.clientSection} ${open ? aa.clientSectionOpen : ""}`}
      >
        <button
          type="button"
          className={aa.clientSectionToggle}
          onClick={onToggle}
          aria-expanded={open}
        >
          <span className={aa.clientSectionToggleMain}>
            <h2 className={aa.clientSectionTitle}>{title}</h2>
            {!open && preview ? (
              <span className={aa.clientSectionPreview}>{preview}</span>
            ) : null}
          </span>
          <span className={aa.clientSectionChevron} aria-hidden />
        </button>
        {open ? <div className={aa.clientSectionBody}>{children}</div> : null}
      </section>
    );
  }

  return (
    <section
      id={id}
      className={`${s.clientProfileSection} ${open ? s.clientProfileSectionOpen : s.clientProfileSectionClosed}`}
    >
      <button
        type="button"
        className={s.clientProfileSectionToggle}
        onClick={onToggle}
        aria-expanded={open}
      >
        <span className={s.clientProfileSectionToggleMain}>
          <h2 className={s.clientProfileSectionTitle}>{title}</h2>
          {!open && preview ? (
            <span className={s.clientProfileSectionPreview}>{preview}</span>
          ) : null}
        </span>
        <span className={s.clientProfileSectionChevron} aria-hidden>
          {open ? "−" : "+"}
        </span>
      </button>
      {open ? <div className={s.clientProfileSectionBody}>{children}</div> : null}
    </section>
  );
}

export function ClientProfileSummaryStrip({ items, onJump }) {
  const isApp = useAdminHubUi();
  if (!items.length) return null;

  if (isApp) {
    return (
      <div className={aa.clientSummaryGroup}>
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className={aa.clientSummaryChip}
            onClick={() => onJump(item.id)}
          >
            <span className={aa.clientSummaryChipLabel}>{item.label}</span>
            <strong className={aa.clientSummaryChipValue}>{item.value}</strong>
            {item.hint ? (
              <span className={aa.clientSummaryChipHint}>{item.hint}</span>
            ) : null}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={s.clientProfileSummaryStrip}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={s.clientProfileSummaryChip}
          onClick={() => onJump(item.id)}
        >
          <span className={s.clientProfileSummaryChipLabel}>{item.label}</span>
          <strong className={s.clientProfileSummaryChipValue}>{item.value}</strong>
          {item.hint ? (
            <span className={s.clientProfileSummaryChipHint}>{item.hint}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
